const ENProjectPremisses = {
	"Adicionar Premissa": "Add Premisse",
	"Nenhuma premissa adicionada": "No added premise",
	"Premissa": "Premise"
	
};

export default ENProjectPremisses;
